import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/deposit/cashapp';
import {getCashAppRecipient, createCashAppOrder} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';

import LoaderPage from '../../../components/loader_page';

import Enter from './enter';
import Send from './send';
import Alert from './alert';

export default ({setMethod}) => {
    const {cashapp_recipient, cashapp_order} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    const [stage, setStage] = useState('enter'),
          [data, setData] = useState(null);

    useEffect(() => {
        if(!cashapp_recipient)
            dispatch(getCashAppRecipient(navigate));
    }, [cashapp_recipient]);

    if(!cashapp_recipient)
        return <LoaderPage />

    if(stage === "enter")
        return <Enter setMethod={setMethod} onNext={data => {
            data = {
                ...data,
                amount: parseFloat(parseFloat(data.amount).toFixed(2))
            };

            dispatch(createCashAppOrder({
                amount: data.amount,
                cashtag: data.cashtag
            }, navigate));

            setData(data);
            setStage('send');
        }} />

    if(stage === "send")
        return <Send data={data} recipient={cashapp_recipient} cashapp_order={cashapp_order} onPayment={() => setStage('alert')} />;

    return <Alert order={cashapp_order} />
}